import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';

export class ScipMissingTranslationHandler implements MissingTranslationHandler {
  constructor(private logger: NGXLogger) {}
  handle(params: MissingTranslationHandlerParams): string {
    this.logger.warn('MissingTranslation, please report that this here is missing', params.key);
    // The default behavior for missing translations is to just show the key,
    // until it is not defined different we stick to that behavior.
    return params.key;
  }
}
